import { Pwerm2InputYearDebtInstrumentCalculationResultsPeriodTotalDto } from '@app/shared/models/contracts/pwerm2-input-calculation-results-dto';
import {
  amountRules,
  enteredPercentageViewRules,
} from '@app/shared/components/cell-value/CellValueConfigurations';
import { enumKeyByValue } from '@app/shared/helpers';
import { CouponType } from '@app/shared/models/contracts/enums/shared-enums';
import { Alignment } from '@app/shared/enums/alignment.enum';
import { mapCouponTypeInterestToTranslationWithHover } from '@app/shared/utils/CouponInterestTranslationHelper';

export const FIELD_NAME_COUPON_TYPE = 'couponType';
export const FIELD_NAME_COUPON_PERCENTAGE = 'couponPc';
export const FIELD_NAME_CASH_PAY_PROPORTION = 'cashPayProportionPc';
export const FIELD_NAME_CASH_PAY_INTEREST = 'cashPayInterest';
export const FIELD_NAME_OPENING_BALANCE = 'openingBalance';
export const FIELD_NAME_CLOSING_BALANCE = 'closingBalance';
export const FIELD_NAME_ADDITIONS = 'additions';
export const FIELD_NAME_ACCRUED_INTEREST = 'accruedInterest';

export const isBoldRow = (
  key: keyof Pwerm2InputYearDebtInstrumentCalculationResultsPeriodTotalDto
) => key === FIELD_NAME_OPENING_BALANCE || key === FIELD_NAME_CLOSING_BALANCE;

export const resolveDisplayValues = (
  key: keyof Pwerm2InputYearDebtInstrumentCalculationResultsPeriodTotalDto,
  periodTotal: Pwerm2InputYearDebtInstrumentCalculationResultsPeriodTotalDto | undefined
): {
  displayValue: string | number | undefined;
  longText: string | undefined;
  isNoCoupon: boolean;
} => {
  if (!periodTotal) {
    return { displayValue: undefined, longText: undefined, isNoCoupon: false };
  }

  const isNoCoupon = periodTotal.couponType === enumKeyByValue(CouponType, CouponType.NoCoupon);

  if (key === FIELD_NAME_COUPON_TYPE) {
    const couponTypeValues = mapCouponTypeInterestToTranslationWithHover(periodTotal.couponType);
    return {
      displayValue: couponTypeValues?.short,
      longText: couponTypeValues?.full,
      isNoCoupon,
    };
  }

  return {
    displayValue: isNoCoupon && key === FIELD_NAME_COUPON_PERCENTAGE ? undefined : periodTotal[key],
    longText: undefined,
    isNoCoupon,
  };
};

export const getCellValueProps = (
  key: keyof Pwerm2InputYearDebtInstrumentCalculationResultsPeriodTotalDto,
  isNoCoupon: boolean
) => ({
  ...(isTextRow(key, isNoCoupon) ? {} : amountRules),
  ...(isPercentageRow(key, isNoCoupon) ? enteredPercentageViewRules : {}),
  strong: isBoldRow(key),
  alignment: Alignment.Right,
});

const isPercentageRow = (
  key: keyof Pwerm2InputYearDebtInstrumentCalculationResultsPeriodTotalDto,
  isNoCoupon?: boolean
) => {
  switch (key) {
    case FIELD_NAME_CASH_PAY_PROPORTION:
      return true;
    case FIELD_NAME_COUPON_PERCENTAGE:
      return !isNoCoupon;
    default:
      return false;
  }
};

const isTextRow = (
  key: keyof Pwerm2InputYearDebtInstrumentCalculationResultsPeriodTotalDto,
  isNoCoupon?: boolean
) => key === FIELD_NAME_COUPON_TYPE || Boolean(isNoCoupon && key === FIELD_NAME_COUPON_PERCENTAGE);
